import { render } from "./SideNav.vue?vue&type=template&id=11d5b00a&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"

import "./SideNav.vue?vue&type=style&index=0&id=11d5b00a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\h_fujii\\Desktop\\task-app2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d5b00a"]])

export default __exports__